import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import * as S from './styles';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { ReactComponent as BingSpecificsIcon } from 'common/images/icon-bing-specifics.svg'
import { Loader } from 'components/Loader'
import { serviceLoading } from 'common/loaderReducer';
import { GET_DEALERINFO_API_REQUEST } from 'features/Dealers/Listings/Info/state/actionTypes';
import { POST_DEALERLM_API_REQUEST } from 'features/Dealers/Listings/Data/state/actionTypes';
import { editLiveDealerLMInfo, postDealerLMAPI } from 'features/Dealers/Listings/Data/state/actions';
import { getSyncError, phoneFormat } from 'features/Dealers/Listings/utils';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';

const BingSpecifics = (props: any) => {
    const [saving, setSaving] = React.useState(false);
    const [firstLoad, setFirstLoad] = React.useState(true);
    const [editingState, setEditingState] = React.useState(InputIconFieldState.VIEW);
    const dispatch = useDispatch();

    const {
        isLoading,
        isSaving,
        live,
        listingSyncErrors,
        selectedListingId,
        selectedDealerId,
        originalLMDealerInfo
    } = useSelector((rootState: RootState) => {
        return {
            isLoading: serviceLoading(rootState, [GET_DEALERINFO_API_REQUEST]),
            isSaving: serviceLoading(rootState, [POST_DEALERLM_API_REQUEST]),
            live: rootState.dealers.listing.currentListing.data.liveDealerLMInfo,
            originalLMDealerInfo: rootState.dealers.listing.currentListing.data.dealerLMInfo,
            listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId) {
            setSaving(false);
            dispatch(getListingSyncErrors(selectedListingId??""));
            dispatch(getDealerListingsWithErrors(selectedDealerId??""));
        }
        setFirstLoad(false);
    }, [isSaving])

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return (
                <Loader/>
        )
    } else {
        return (
            <S.SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Bing Custom Fields'}
                    state={saving ? InputIconFieldState.LOADING : editingState}
                    renderValue={renderBingSpecifics}
                    renderIcon={() => { return (<S.IconContainer><BingSpecificsIcon /></S.IconContainer>) }}
                    showAlertIcon={getSyncError('bingSpecifics',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('bingSpecifics',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('bingSpecifics',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('bingSpecifics',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action) }}
                    disabled={false}
                    disableBackground={true}
                />
            </S.SectionWrapper>
        )
    }

    function onFieldActionClick(action: InputIconFieldAction) {
        switch (action) {
            case InputIconFieldAction.SAVE:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    setSaving(true);
                    if (live){
                        if (live.customBingPhoneNumber) live.customBingPhoneNumber = live.customBingPhoneNumber.replace(/\D/g, '');
                        dispatch(postDealerLMAPI(selectedListingId ?? "", "", live))
                    }
                    break;
                }
            case InputIconFieldAction.EDIT:
                {
                    setEditingState(InputIconFieldState.EDIT)
                    break;
                }
            case InputIconFieldAction.CANCEL:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    dispatch(editLiveDealerLMInfo(originalLMDealerInfo))
                }
        }
    }

    function renderBingSpecifics() {
        if (editingState === InputIconFieldState.VIEW || editingState === InputIconFieldState.LOADING) {
            if (live) {
                return ( <>
                            <S.Row>
                                <S.Label>Custom Phone Number</S.Label>
                                <S.Label>Custom URL</S.Label>
                            </S.Row>
                            
                            {((!live.customBingPhoneNumber || live.customBingPhoneNumber==="") && (!live.customBingURL || live.customBingURL===""))
                            ?<S.Row><S.EmptyText>Click edit to add custom description here</S.EmptyText></S.Row>
                            :<S.Row flexFlow='wrap'>
                                <S.ViewLabelNumber> {phoneFormat(live.customBingPhoneNumber??"")} </S.ViewLabelNumber> 
                                <S.ViewLabelUrl>{live.customBingURL??''}</S.ViewLabelUrl>
                            </S.Row>}
                        </>)
            }
        } else if (editingState === InputIconFieldState.EDIT && live) {;
            return ( <>
                        <S.Row>
                            <S.Label>Custom Phone Number</S.Label>
                            <S.Label>Custom URL</S.Label>
                        </S.Row>

                        <S.Row>
                            <S.Input
                                value={phoneFormat(live.customBingPhoneNumber??"")}
                                onChange={(e) => onBingChange('customBingPhoneNumber', `${e.target.value}`)}
                            />
                            <S.Input
                            value={live.customBingURL??''}
                            onChange={(e) => onBingChange('customBingURL', `${e.target.value}`)}
                            />
                        </S.Row>
                    </>);
        }
    }

    function onBingChange(field: string, value: string) {
        if (live) {
            if (field==="customBingPhoneNumber") value = phoneFormat(value).replace(/[^0-9]/g,'');
            dispatch(editLiveDealerLMInfo({ ...live, [field]: value ?? "" }))
        }
    }


}

export default BingSpecifics;